// Mirrors QuotationStatus enum (backend: com.kervolt.pos.enums.QuotationStatus)
export type QuotationStatus = 'DRAFT' | 'SENT' | 'CONFIRMED' | 'REJECTED' | 'EXPIRED' | 'CONVERTED';

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

export const QUOTATION_STATUS_COLORS: Record<QuotationStatus, ChipColor> = {
  DRAFT: 'default',
  SENT: 'info',
  CONFIRMED: 'primary',
  REJECTED: 'error',
  EXPIRED: 'warning',
  CONVERTED: 'success',
};

// Mirrors QuotationLineDTO (IdHolder gives id)
export interface QuotationLine {
  id: string;
  quotationId: string;
  description: string;
  quantity: number;
  unitPrice: number;
  taxRatePct: number;
  lineTax?: number;
  lineTotal?: number;
  revenueAccountId?: string;
  segmentId?: string;
}

// Mirrors QuotationDTO (IdHolder gives id)
export interface Quotation {
  id: string;
  quotationNumber?: string;
  customerId: string;
  customerName?: string;
  quotationDate: string;
  validUntil: string;
  status: QuotationStatus;
  confirmedById?: string;
  confirmedAt?: string;
  rejectReason?: string;
  convertedInvoiceId?: string;
  subtotal: number;
  taxAmount: number;
  totalAmount: number;
  notes?: string;
  clonedFromId?: string;
  institutionId: string;
  lines: QuotationLine[];
}

// Mirrors QuotationLineCreateDTO
export interface QuotationLineCreateDTO {
  description: string;
  quantity: number;
  unitPrice: number;
  taxRatePct: number;
  revenueAccountId?: string;
  segmentId?: string;
}

// Mirrors QuotationCreateDTO
export interface QuotationCreateDTO {
  customerId: string;
  quotationDate: string;
  validUntil?: string;
  notes?: string;
  institutionId: string;
  lines: QuotationLineCreateDTO[];
}

// Mirrors QuotationRejectDTO — field name is "reason" (not rejectReason)
export interface QuotationRejectDTO {
  reason: string;
}

export interface QuotationPage {
  content: Quotation[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}
